import React, { Component } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import "./style.scss";
import { createPortal } from "react-dom";

const ANIMATION_MS = 280;

class Modal extends Component {
	static propTypes = {
		size: PropTypes.oneOf([1200, 1000, 800, 700, 600, 500, 500, 400]),
		closeIcon: PropTypes.bool,
		isOpen: PropTypes.bool,
		toggle: PropTypes.func,
		backdrop: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.oneOf(["static"])
		]),
		scroll: PropTypes.bool
	};

	static defaultProps = {
		size: 500,
		closeIcon: true,
		isOpen: false,
		backdrop: true,
		scroll: false
	};

	state = {
		mounted: false,
		entered: false
	};

	body = null;
	enterRaf = null;
	exitTimer = null;

	setBodyOverflow = isOpen => {
		if (this.body) {
			this.body.style.overflow = isOpen ? "hidden" : "";
		}
	};

	clearTimers = () => {
		if (this.enterRaf) {
			cancelAnimationFrame(this.enterRaf);
			this.enterRaf = null;
		}
		if (this.exitTimer) {
			clearTimeout(this.exitTimer);
			this.exitTimer = null;
		}
	};

	openWithAnimation = () => {
		this.clearTimers();
		this.setBodyOverflow(true);
		this.setState({ mounted: true, entered: false }, () => {
			this.enterRaf = requestAnimationFrame(() => {
				this.enterRaf = requestAnimationFrame(() => {
					this.setState({ entered: true });
				});
			});
		});
	};

	closeWithAnimation = () => {
		this.clearTimers();
		this.setState({ entered: false });
		this.exitTimer = setTimeout(() => {
			this.setState({ mounted: false });
			this.setBodyOverflow(false);
		}, ANIMATION_MS);
	};

	componentDidMount() {
		this.body = document.body;
		if (this.props.isOpen) {
			this.openWithAnimation();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isOpen === this.props.isOpen) return;

		if (this.props.isOpen) {
			this.openWithAnimation();
		} else {
			this.closeWithAnimation();
		}
	}

	componentWillUnmount() {
		this.clearTimers();
		this.setBodyOverflow(false);
	}

	_toggleAction = () => {
		this.props.toggle();
	};

	render() {
		const { size, backdrop, className = "" } = this.props;
		const { mounted, entered } = this.state;

		if (!mounted) {
			return null;
		}

		const classNames = cx(
			"sidebar-modal__content",
			size && `max-w-${size}`,
			className,
			entered && "sidebar-modal__content--entered"
		);

		return createPortal(
			<div
				className={cx("sidebar-modal", entered && "sidebar-modal--entered")}
			>
				<div
					className={cx(
						"sidebar-modal__overlay",
						entered && "sidebar-modal__overlay--entered"
					)}
					onClick={backdrop ? this._toggleAction : undefined}
					onKeyDown={e =>
						e.key === "Escape" && backdrop && this._toggleAction()
					}
					role="button"
					tabIndex={-1}
				/>
				<div
					className={cx(
						classNames,
						"h-full overflow-y-auto fixed top-0 right-0 scrollable--hidden"
					)}
					style={{ overscrollBehavior: "contain" }}
				>
					{this.props.children}
				</div>
			</div>,
			document.body
		);
	}
}

export default Modal;
